import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import Switch from '@material-ui/core/Switch';
import React, {
  Component,
} from 'react';
import Directives from '../../../Directives/Directives';
import generalClasses from '../../GeneralFormComponent/GeneralFormComponent.module.scss';
import {
  IToggleButtonField,
} from '../formFields';
import { FormControl } from '@material-ui/core';

interface IProps extends IToggleButtonField {
  errors: any;
  touched: any;

  onChange(name: string, value: boolean): any;
}

class ToggleButtonField extends Component<IProps> {
  render() {
    return (
      <FormControl>
        <FormControlLabel
          className={generalClasses.filed}
          control={(
            <Switch
              name={this.props.name}
              checked={this.props.value}
              onChange={(event: any) => this.props.onChange(this.props.name, event.target.checked)}
              color="primary"
            />
          )}
          label={this.props.value ? this.props.activeLabel : this.props.inactiveLabel}
        />
        <Directives dIf={this.props.errors[this.props.name] && this.props.touched[this.props.name]}>
          <FormHelperText className={generalClasses.error}>{this.props.errors[this.props.name]}</FormHelperText>
        </Directives>
      </FormControl>
    );
  }
}

export default ToggleButtonField;
